import axios from 'axios'
import {
  SUBMIT_COLLECTION_REQUEST,
  SUBMIT_COLLECTION_SUCCESS,
  SUBMIT_COLLECTION_FAIL,
  SUBMIT_COLLECTION_RESET,
  GET_MY_COLLECTIONS_REQUEST,
  GET_MY_COLLECTIONS_SUCCESS,
  GET_MY_COLLECTIONS_FAIL,
  GET_MY_COLLECTIONS_RESET,
  GET_MY_PROCESSES_REQUEST,
  GET_MY_PROCESSES_SUCCESS,
  GET_MY_PROCESSES_FAIL,
  GET_MY_PROCESSES_RESET,
  GET_MY_STATISTICS_REQUEST,
  GET_MY_STATISTICS_SUCCESS,
  GET_MY_STATISTICS_FAIL,
  GET_MY_STATISTICS_RESET,
  UPDATE_COLLECTION_REQUEST,
  UPDATE_COLLECTION_SUCCESS,
  UPDATE_COLLECTION_FAIL,
  UPDATE_COLLECTION_RESET,
  DELETE_COLLECTION_REQUEST,
  DELETE_COLLECTION_SUCCESS,
  DELETE_COLLECTION_FAIL,
  DELETE_COLLECTION_RESET,
  GET_PROCESS_DEFAULTS_REQUEST,    // Add this
  GET_PROCESS_DEFAULTS_SUCCESS,    // Add this
  GET_PROCESS_DEFAULTS_FAIL,
} from '../constants/dailyCollectionConstants';
import { logout } from './userActions';

const baseUrl = process.env.REACT_APP_API_URL;

export const submitCollection = (collectionData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SUBMIT_COLLECTION_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${baseUrl}/dailyCollection/submit`,
      collectionData,
      config
    );

    dispatch({
      type: SUBMIT_COLLECTION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: SUBMIT_COLLECTION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getMyCollections = (queryParams) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_MY_COLLECTIONS_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${baseUrl}/dailyCollection/my-collections${queryParams ? `?${queryParams}` : ''}`,
      config
    );

    dispatch({
      type: GET_MY_COLLECTIONS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: GET_MY_COLLECTIONS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getMyProcesses = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_MY_PROCESSES_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${baseUrl}/dailyCollection/my-processes`,
      config
    );

    dispatch({
      type: GET_MY_PROCESSES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: GET_MY_PROCESSES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getMyStatistics = (queryParams) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_MY_STATISTICS_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${baseUrl}/dailyCollection/my-statistics${queryParams ? `?${queryParams}` : ''}`,
      config
    );

    dispatch({
      type: GET_MY_STATISTICS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: GET_MY_STATISTICS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateCollection = (id, collectionData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: UPDATE_COLLECTION_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(
      `${baseUrl}/dailyCollection/update/${id}`,
      collectionData,
      config
    );

    dispatch({
      type: UPDATE_COLLECTION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: UPDATE_COLLECTION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteCollection = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DELETE_COLLECTION_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.delete(
      `${baseUrl}/dailyCollection/delete/${id}`,
      config
    );

    dispatch({
      type: DELETE_COLLECTION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: DELETE_COLLECTION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getProcessDefaults = (processId) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_PROCESS_DEFAULTS_REQUEST });

    const { userLogin: { userInfo } } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    // Use baseUrl instead of hardcoded API path
    const { data } = await axios.get(
      `${baseUrl}/dailyCollection/process-defaults/${processId}`,
      config
    );

    dispatch({
      type: GET_PROCESS_DEFAULTS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: GET_PROCESS_DEFAULTS_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    });
  }
};
